<template>
    <footer id="colophon" class="site-footer">
        <div class="image-block" :style="image">
        </div>
        <div class="site-info">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-6">
                        <div class="nagivation-1 content-block">
                            <div class="nav">
                                <div class="heading">
                                    <h3 class="h3 white">À propos</h3>
                                </div>
                                <div class="menu-footer_menu-container">
                                    <ul id="footer-menu-1" class="menu">
                                        <li id="menu-item-77"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-77"><a
                                            href="https://www.ewigo.com/points-de-vente/">Le réseau Ewigo</a>
                                        </li>
                                        <li id="menu-item-78"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-78"><a
                                            href="https://ewigo-franchise.com/pourquoi-nous-rejoindre/">Devenir
                                            Franchisé</a></li>
                                        <li id="menu-item-79"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-79">
                                            <a :href="route('minisite.faq')">FAQ</a></li>

                                        <li id="menu-item-80"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-80">
                                            <a href="https://www.ewigo.com/actualites/">Actualités</a>
                                        </li>
                                       <li id="menu-item-81"
                                           class="menu-item menu-item-type-custom menu-item-object-custom menu-item-81">
                                           <a href="https://www.ewigo.com/mentions-legales/">Mentions
                                               légales</a></li>
                                        <li id="menu-item-796"
                                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-796">
                                            <a
                                                :href="route('minisite.cgv')">Conditions
                                                générales de vente</a></li>

                                        <li id="menu-item-786"
                                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-786">
                                            <a
                                                href="https://www.ewigo.com/conditions-generales-dutilisation/">Conditions
                                                générales d’utilisation</a></li>
                                        <li id="menu-item-791"
                                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-791">
                                            <a href="https://www.ewigo.com/donnees-personnelles/">Données
                                                personnelles</a></li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="nagivation-2 content-block">
                            <div class="nav">
                                <div class="heading">
                                    <h3 class="h3 white">Nos services</h3>
                                </div>
                                <div class="menu-footer_menu_2-container">
                                    <ul id="footer-menu-2" class="menu">
                                        <li id="menu-item-713"
                                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-713">
                                            <a :href="route('minisite.vendre')">Vente</a>
                                        </li>
                                        <li id="menu-item-712"
                                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-712">
                                            <a
                                                :href="route('minisite.acheter')">Achat</a>
                                        </li>
                                        <li id="menu-item-716"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-716">
                                            <a
                                                :href="route('minisite.services')+'#garantie'">Garantie</a>
                                        </li>
                                        <li id="menu-item-717"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-717">
                                            <a
                                                :href="route('minisite.services')+'#paiement-securise'">Paiement
                                                Sécurisé</a></li>
                                        <li id="menu-item-86"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-86">
                                            <a
                                                :href="route('minisite.services')+'#financement'">Financement</a>
                                        </li>
                                        <li id="menu-item-87"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-87">
                                            <a
                                                :href="route('minisite.services')+'#livraison'">Livraison</a>
                                        </li>
                                        <li id="menu-item-87"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-87">
                                            <a
                                                :href="route('minisite.services')+'#packs'">Packs</a>
                                        </li>
                                        <li v-if="!hideCarteGrise" id="menu-item-88"
                                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-88">
                                            <a :href="route('minisite.services')+'#carte-grise'">Carte Grise</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="contact-details content-block">
                            <div class="detail">
                                <div class="heading">
                                    <h3 class="h3 white">Contact</h3>
                                </div>
                                <p class="title white">Siège social
                                    :<br>Ewigo {{agency.name}}<br>{{agency.address}},<br>{{agency.postcode}} {{agency.city}}</p>
                                <img src="/img/vu-tv-2.png" alt="Vu à la télévision sur TF1 Auto-moto et France 2 Télé Matin" class="view-on-tv" />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="contact-social content-block">
                            <img src="https://www.ewigo.com/wp-content/uploads/2026/04/Google-2026-noir-bulle.png"
                                class="google-reviews">

                            <p>Suivez-nous sur</p>

                            <div class="footer-networks">
                                <a :href="agency.facebook || 'https://www.facebook.com/AgenceAutomobile/'" target="_blank"><img
                                        src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/facebook.png"></a>
                                <a :href="agency.instagram || 'https://www.instagram.com/ewigofrance/'" target="_blank"><img
                                        src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/instagram.png"></a>
                                <a href="https://www.tiktok.com/@ewigo_france" target="_blank"><img
                                        src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/tiktok.png"></a>
                                <a :href="agency.youtube || 'https://www.youtube.com/channel/UCfQScblYW971yS5qK_OE0CA'" target="_blank"><img
                                        src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/youtube.png"></a>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright">
            @Ewigo2021 </div>
    </footer><!-- #colophon -->

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none"
        style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;">
        <defs>
            <filter id="wp-duotone-dark-grayscale">
                <feColorMatrix color-interpolation-filters="sRGB" type="matrix"
                    values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 " />
                <feComponentTransfer color-interpolation-filters="sRGB">
                    <feFuncR type="table" tableValues="0 0.49803921568627" />
                    <feFuncG type="table" tableValues="0 0.49803921568627" />
                    <feFuncB type="table" tableValues="0 0.49803921568627" />
                    <feFuncA type="table" tableValues="1 1" />
                </feComponentTransfer>
                <feComposite in2="SourceGraphic" operator="in" />
            </filter>
        </defs>
    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none"
        style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;">
        <defs>
            <filter id="wp-duotone-grayscale">
                <feColorMatrix color-interpolation-filters="sRGB" type="matrix"
                    values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 " />
                <feComponentTransfer color-interpolation-filters="sRGB">
                    <feFuncR type="table" tableValues="0 1" />
                    <feFuncG type="table" tableValues="0 1" />
                    <feFuncB type="table" tableValues="0 1" />
                    <feFuncA type="table" tableValues="1 1" />
                </feComponentTransfer>
                <feComposite in2="SourceGraphic" operator="in" />
            </filter>
        </defs>
    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none"
        style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;">
        <defs>
            <filter id="wp-duotone-purple-yellow">
                <feColorMatrix color-interpolation-filters="sRGB" type="matrix"
                    values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 " />
                <feComponentTransfer color-interpolation-filters="sRGB">
                    <feFuncR type="table" tableValues="0.54901960784314 0.98823529411765" />
                    <feFuncG type="table" tableValues="0 1" />
                    <feFuncB type="table" tableValues="0.71764705882353 0.25490196078431" />
                    <feFuncA type="table" tableValues="1 1" />
                </feComponentTransfer>
                <feComposite in2="SourceGraphic" operator="in" />
            </filter>
        </defs>
    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none"
        style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;">
        <defs>
            <filter id="wp-duotone-blue-red">
                <feColorMatrix color-interpolation-filters="sRGB" type="matrix"
                    values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 " />
                <feComponentTransfer color-interpolation-filters="sRGB">
                    <feFuncR type="table" tableValues="0 1" />
                    <feFuncG type="table" tableValues="0 0.27843137254902" />
                    <feFuncB type="table" tableValues="0.5921568627451 0.27843137254902" />
                    <feFuncA type="table" tableValues="1 1" />
                </feComponentTransfer>
                <feComposite in2="SourceGraphic" operator="in" />
            </filter>
        </defs>
    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none"
        style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;">
        <defs>
            <filter id="wp-duotone-midnight">
                <feColorMatrix color-interpolation-filters="sRGB" type="matrix"
                    values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 " />
                <feComponentTransfer color-interpolation-filters="sRGB">
                    <feFuncR type="table" tableValues="0 0" />
                    <feFuncG type="table" tableValues="0 0.64705882352941" />
                    <feFuncB type="table" tableValues="0 1" />
                    <feFuncA type="table" tableValues="1 1" />
                </feComponentTransfer>
                <feComposite in2="SourceGraphic" operator="in" />
            </filter>
        </defs>
    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none"
        style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;">
        <defs>
            <filter id="wp-duotone-magenta-yellow">
                <feColorMatrix color-interpolation-filters="sRGB" type="matrix"
                    values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 " />
                <feComponentTransfer color-interpolation-filters="sRGB">
                    <feFuncR type="table" tableValues="0.78039215686275 1" />
                    <feFuncG type="table" tableValues="0 0.94901960784314" />
                    <feFuncB type="table" tableValues="0.35294117647059 0.47058823529412" />
                    <feFuncA type="table" tableValues="1 1" />
                </feComponentTransfer>
                <feComposite in2="SourceGraphic" operator="in" />
            </filter>
        </defs>
    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none"
        style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;">
        <defs>
            <filter id="wp-duotone-purple-green">
                <feColorMatrix color-interpolation-filters="sRGB" type="matrix"
                    values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 " />
                <feComponentTransfer color-interpolation-filters="sRGB">
                    <feFuncR type="table" tableValues="0.65098039215686 0.40392156862745" />
                    <feFuncG type="table" tableValues="0 1" />
                    <feFuncB type="table" tableValues="0.44705882352941 0.4" />
                    <feFuncA type="table" tableValues="1 1" />
                </feComponentTransfer>
                <feComposite in2="SourceGraphic" operator="in" />
            </filter>
        </defs>
    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none"
        style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;">
        <defs>
            <filter id="wp-duotone-blue-orange">
                <feColorMatrix color-interpolation-filters="sRGB" type="matrix"
                    values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 " />
                <feComponentTransfer color-interpolation-filters="sRGB">
                    <feFuncR type="table" tableValues="0.098039215686275 1" />
                    <feFuncG type="table" tableValues="0 0.66274509803922" />
                    <feFuncB type="table" tableValues="0.84705882352941 0.41960784313725" />
                    <feFuncA type="table" tableValues="1 1" />
                </feComponentTransfer>
                <feComposite in2="SourceGraphic" operator="in" />
            </filter>
        </defs>
    </svg>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {
        Link,
    },
    props: {
        agency: Object,
        bg_img: String,
        hideCarteGrise: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            image: {
                backgroundImage: "url('" + this.bg_img + "')"
            }
        };
    }
}
</script>
<style scoped>
.footer-networks img {
    width: 100%;
    max-height: 40px;
}
.site-info {
    padding: 30px 0 0 0;
}
.copyright {
    padding: 0;
}
.site-footer .contact-social .footer-networks a img {
    width: auto;
}
@media screen and (max-width : 768px) {
    .site-footer .contact-social .google-reviews {
        max-width: 80%;
    }
}
.site-footer .image-block {
    background-attachment: initial;
}
.contact-details .title {
    opacity: 0.8;
    font-weight: 300;
}
@media screen and (max-width : 991px) {
    .footer-networks {
        padding: 0 20px;
        justify-content: space-evenly !important;
    }
}


</style>
